"use client";

import { useState, useEffect } from "react";
import { useReducedMotion } from "@/lib/motion";

export function CountUp({
  to,
  suffix = "",
  prefix = "",
  decimals = 0,
  active,
}: {
  to: number | string;
  suffix?: string;
  prefix?: string;
  decimals?: number;
  active: boolean;
}) {
  const [count, setCount] = useState(0);
  const reduced = useReducedMotion();
  useEffect(() => {
    if (typeof to === "string") return;
    if (!active || reduced) {
      setCount(to);
      return;
    }
    const dur = 1600,
      start = performance.now();
    const f = (now: number) => {
      const t = Math.min((now - start) / dur, 1);
      setCount(parseFloat(((1 - Math.pow(1 - t, 3)) * to).toFixed(decimals)));
      if (t < 1) requestAnimationFrame(f);
    };
    requestAnimationFrame(f);
  }, [active, to, decimals, reduced]);
  if (typeof to === "string")
    return (
      <span>
        {prefix}
        {to}
        {suffix}
      </span>
    );
  return (
    <span>
      {prefix}
      {decimals > 0 ? count.toFixed(decimals) : Math.floor(count)}
      {suffix}
    </span>
  );
}
